import { SkinnableComponent } from '../../../types/component-skin';
import { useLoginLogic } from './LoginLogic';
import BasicLoginSkin from './skins/BasicLoginSkin';
import { COMPONENT_TYPES } from '../../../constants';

/**
 * Login component with skin support
 */
export const LoginSkinnable: SkinnableComponent = {
  type: COMPONENT_TYPES.LOGIN,
  name: '로그인',
  category: 'auth',
  options: [],
  defaultSkin: 'basic',
  internalSkins: {
    basic: BasicLoginSkin as any
  },
  useLogic: useLoginLogic as any,
  defaultProps: {
    title: '로그인',
    redirectPath: '/',
    backgroundType: 'image',
    backgroundUrl: '',
    buttonColor: '#007bff',
    titleColor: '#333333',
    labelColor: '#333333',
    inputTextColor: '#333333',
    redirectUrl: '/',
    style: {
      padding: '20px',
      backgroundColor: '#fff',
      borderRadius: '8px',
      boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
      maxWidth: '500px',
      margin: '30px auto'
    }
  }
};